import { BsModalService } from 'ngx-bootstrap';
import { ModalControlComponent } from '../modal-control/modal-control.component';
import * as i0 from "@angular/core";
import * as i1 from "ngx-bootstrap/modal";
var ModalControlService = /** @class */ (function () {
    function ModalControlService(modalService) {
        this.modalService = modalService;
    }
    ModalControlService.prototype.launchModal = function (id, title, type, modalClass, expandSummary) {
        var _this = this;
        if (modalClass === void 0) { modalClass = ""; }
        if (expandSummary === void 0) { expandSummary = false; }
        var initialState = {
            componentId: id,
            title: title,
            type: type,
            class: modalClass,
            expandSummary: expandSummary
        };
        if (this.modalService.getModalsCount() > 0) {
            document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.remove('show');
        }
        this.modalRef = this.modalService.show(ModalControlComponent, { class: 'modal-dialog-centered modal-control ' + modalClass, ignoreBackdropClick: true, keyboard: false, initialState: initialState });
        this.modalService.onHide.subscribe(function (reason) {
            if (_this.modalService.getModalsCount() > 0) {
                document.querySelectorAll('.modal.fade').item(_this.modalService.getModalsCount() - 1).classList.add('show');
            }
        });
    };
    ModalControlService.ngInjectableDef = i0.defineInjectable({ factory: function ModalControlService_Factory() { return new ModalControlService(i0.inject(i1.BsModalService)); }, token: ModalControlService, providedIn: "root" });
    return ModalControlService;
}());
export { ModalControlService };
